(() => {
  // =====================================================================
  // Next stock due message
  // Reads the "Next due into warehouse" date (variant metafield
  // custom.next_due_date, filled from Business Central PO lines) via the
  // product.nextdue alternate template, and shows it only when the
  // selected variant is out of stock. If the estimate has passed by up to
  // 14 days it says "Replenishment estimated: Due Soon"; older dates are hidden.
  // Debug: add ?po-debug=1 to the URL.
  // =====================================================================
  const CONFIG = {
    containerSelector: "#next-po-message",
    preferredHookSelector: "#po-hook",
    view: "nextdue",
    showWhenQtyAtOrBelow: 0,
    bookingInDays: 14,
  };

  let debug = false;
  try {
    debug =
      new URLSearchParams(location.search).get("po-debug") === "1" ||
      localStorage.getItem("po-debug") === "1";
  } catch (e) {}
  const log = (...a) => { if (debug) console.info("[PO]", ...a); };

  function ensureStyles() {
    if (document.getElementById("po-inline-style")) return;
    const style = document.createElement("style");
    style.id = "po-inline-style";
    style.textContent = `
      #next-po-message { margin: 22px 0 4px 0; font-size: 0.9rem; }
      #next-po-message .po-wrap { margin: 0; }
      #next-po-message .po-line-1 { margin: 0; }
      #next-po-message .po-line-1 strong { font-weight: 700; }
      #next-po-message .po-line-2 { margin: 2px 0 0 0; font-style: italic; opacity: 0.95; }
    `;
    document.head.appendChild(style);
  }

  const esc = (s) =>
    String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

  function markup(label) {
    return `
      <div class="po-wrap" role="status" aria-live="polite">
        <p class="po-line-1"><strong>Replenishment estimated:</strong> <span class="po-date">${esc(label)}</span></p>
      </div>`;
  }

  function bookingMarkup() {
    return `
      <div class="po-wrap" role="status" aria-live="polite">
        <p class="po-line-1"><strong>Replenishment estimated:</strong> <span class="po-date">Due Soon</span></p>
      </div>`;
  }

  const container = () => document.querySelector(CONFIG.containerSelector);
  function show(html) {
    const el = container(); if (!el) return;
    ensureStyles();
    // Show it right under the "Currently out of stock" line so it's easy to spot
    const anchor = document.getElementById("stock-display-wrapper") || document.getElementById("stock-indicator");
    if (anchor && anchor.nextElementSibling !== el) anchor.insertAdjacentElement("afterend", el);
    el.innerHTML = html; el.style.display = "";
  }
  function hide(reason) {
    const el = container(); if (!el) return;
    el.innerHTML = ""; el.style.display = "none"; log("hidden:", reason);
  }

  function currentSku() {
    const hook = document.querySelector(CONFIG.preferredHookSelector);
    if (hook && hook.dataset && hook.dataset.sku) return hook.dataset.sku.trim();
    const ip = document.querySelector('[itemprop="sku"]');
    if (ip) { const v = (ip.getAttribute("content") || ip.textContent || "").trim(); if (v) return v; }
    const lg = document.querySelector("p.product-single__sku, .product__sku, .product-sku, [data-product-sku]");
    if (lg) return (lg.textContent || lg.getAttribute("data-product-sku") || "").trim();
    return "";
  }

  // Week commencing (Monday) label, e.g. "w/c 5 Oct 2026"
  function wcLabel(iso) {
    const [y, m, d] = iso.split("-").map(Number);
    const dt = new Date(y, m - 1, d);
    dt.setDate(dt.getDate() - ((dt.getDay() + 6) % 7));
    return "w/c " + dt.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  }
  function isPast(iso) {
    const [y, m, d] = iso.split("-").map(Number);
    const t = new Date(); t.setHours(0, 0, 0, 0);
    return new Date(y, m - 1, d) < t;
  }

  function daysPast(iso) {
    const [y, m, d] = iso.split("-").map(Number);
    const t = new Date(); t.setHours(0, 0, 0, 0);
    return Math.round((t - new Date(y, m - 1, d)) / 86400000);
  }

  let dataPromise = null;
  function loadData() {
    if (dataPromise) return dataPromise;
    const m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return (dataPromise = Promise.resolve({}));
    const url = location.pathname.slice(0, m.index) + "/products/" + m[1] + "?view=" + CONFIG.view;
    dataPromise = fetch(url, { credentials: "same-origin" })
      .then((r) => (r.ok ? r.text() : "{}"))
      .then((t) => { try { return JSON.parse(t); } catch (e) { log("bad JSON", e); return {}; } })
      .catch((e) => { log("fetch failed", e); return {}; });
    return dataPromise;
  }

  let lastSku = null;
  async function render() {
    const sku = currentSku();
    if (!sku) return hide("no SKU");
    if (sku === lastSku && container() && container().innerHTML) return;
    lastSku = sku;
    const data = await loadData();
    const e = data[sku];
    log("sku", sku, e);
    if (!e || !e.d) return hide("no date");
    if (Number(e.q) > CONFIG.showWhenQtyAtOrBelow) return hide("in stock");
    if (isPast(e.d)) {
      // Estimated arrival has passed: for up to 2 weeks say "Due Soon"
      if (daysPast(e.d) <= CONFIG.bookingInDays) return show(bookingMarkup());
      return hide("date passed");
    }
    show(markup(wcLabel(e.d)));
  }

  const run = () => { lastSku = null; setTimeout(render, 50); };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", render);
  else render();
  document.addEventListener("variant:change", run);
  document.addEventListener("shopify:section:load", run);
  window.__poRefresh = run;
})();